import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const StatusContracts = () => {
  return (
    <SettingsMetaData propertyName={"Status_Contracts"} viewPropertyName={"Status"} />
  );
};
export default StatusContracts;